if (!customElements.get('deferred-media')) {
  customElements.define(
    'deferred-media',
    class DeferredMedia extends HTMLElement {
      constructor() {
        super();
        this.externalVideoHost = this.getAttribute('host');
        this.clickEvent = this.handleClickEvent.bind(this);
      }

      connectedCallback() {
        this.video = this.querySelector('video');
        this.externalVideo = this.querySelector('iframe');
        this.videoToggleBtn = this.querySelector('.video-toggle-btn');

        this.addEventListener('click', this.clickEvent);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.clickEvent);
      }

      handleClickEvent(event) {
        if (!this.contains(event.target)) return;

        if (this.video) this.videoController();
        if (this.externalVideo) this.externalVideoController();
      }

      videoController() {
        if (this.video.paused) {
          this.video.play();
          // setTimeout(() => {
          //   this.videoToggleBtn.textContent = '❚❚';
          // }, 500);
        } else {
          this.video.pause();
        }

        this.videoToggleBtn.textContent = !this.video.paused ? '❚❚' : '▶';
        this.setAttribute('data-video-playing', !this.video.paused);
      }

      externalVideoController() {
        const isPlaying = this.getAttribute('data-video-playing') === 'true';
        const command = isPlaying ? 'pause' : 'play';

        if (this.externalVideoHost === 'youtube') {
          this.externalVideo.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: `${command}Video`,
              args: []
            }),
            '*'
          );
        } else if (this.externalVideoHost === 'vimeo') {
          this.externalVideo.contentWindow.postMessage(
            JSON.stringify({
              method: command
            }),
            '*'
          );
        }

        // Toggle UI State
        this.setAttribute('data-video-playing', !isPlaying);
        this.videoToggleBtn.textContent = !isPlaying ? '❚❚' : '▶';
      }
    }
  )
}